sharpen-progress-bar {
  display: block;

  & + & {
    margin-top: var(--spacing-md);
  }

  .progress-container {
    display: block;
    height: 10px;
    width: 100%;
    border-radius: 10px;
    background-color: var(--color-gray-4);
  }

  .progress-amount {
    height: 100%;
    width: 0;
    border-radius: 10px;
    // Anything smaller than this and the left-side radius looks wrong
    min-width: 2.5%;
  }

  .progress-description {
    margin-top: var(--spacing-xs);
    font-weight: var(--font-weight-semibold);
  }

  &[size="wide"], &[size="wider"] {
    .progress-container, .progress-amount { border-radius: 7px; }
  }

  &[size="wide"]  { .progress-container { height: 20px; } }
  &[size="wider"] { .progress-container { height: 30px; } }

  &[status="low"] {
    .progress-amount { background-color: var(--color-pine); }
    .progress-description { color: var(--color-pine); }
  }

  &[status="elevated"] {
    .progress-amount { background-color: var(--color-orange); }
    .progress-description { color: var(--color-orange); }
  }

  &[status="high"] {
    .progress-amount { background-color: var(--color-red); }
    .progress-description { color: var(--color-red); }
  }

}